import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI, usersAPI, getApiError } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const res = await authAPI.login({ email, password });
      const { access_token, user: userData } = res.data;
      localStorage.setItem('token', access_token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      return userData;
    } catch (error) {
      const msg = getApiError(error, 'Error al iniciar sesión');
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  };

  const registerPremium = async (data) => {
    const res = await authAPI.registerPremium(data);
    return res.data;
  };

  const registerGestor = async (data) => {
    const res = await authAPI.registerGestor(data);
    return res.data;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const refreshUser = async () => {
    try {
      const res = await usersAPI.getMe();
      const userData = res.data;
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
    } catch {
      logout();
    }
  };

  const value = { user, login, logout, loading, registerPremium, registerGestor, refreshUser };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
